<template>
  <div class="asideLeftContainer">

    <!--头部搜索栏-->
    <div class="searchContainer">
      <div class="searchBox">
        <div class="searchLable">
          <el-select v-model="selectValue" size="large" @change="onSelectSearch(selectValue)">
            <el-option :label="item.label" :key="item.value" :value="item.value" v-for="item in options"></el-option>
          </el-select>
        </div>
        <div class="searchInput">
          <el-input class="myInput" v-model="searchValue" @keyup.enter.native="handleSearch" v-if="selectValue!='group_status'" 
          clearable
          placeholder="请输入关键词搜索" />
          <el-select v-model="group_status" @change="tabClick(group_status)" clearable  v-else >
            <el-option label="全部" :key="null" :value="null"></el-option>
            <el-option label="验号中" :key="1" :value="1"></el-option>
            <el-option label="换绑中" :key="2" :value="2"></el-option>
            <el-option label="已完成" :key="3" :value="3"></el-option>
            <el-option label="已取消" :key="4" :value="4"></el-option>
          </el-select>
        </div>
      </div>
    </div>


    <div class="tabsContainer">
      <el-tabs v-model="tabsActiveIndex" :stretch="true" class="window__aside-left"
               >
        <el-tab-pane class="chat-user__list" label="全部" :name="TabsMap['ALL_LIST']">
          <el-scrollbar class="ls-scrollbar scrollbar-wrapper" v-loading="loading"
          v-if="tabsActiveIndex=='0'"
          >
            <div
                v-infinite-scroll="loadMoreThread"
                :infinite-scroll-disabled="busy"
                infinite-scroll-immediate-check="false"
                infinite-scroll-listen-for-event
                infinite-scroll-delay="200"
            >
              <chat-user-item v-for="(item, index) in session_list[tabsActiveIndex]"
                              :star="item.star"
                              :bg="item.bg"
                              :data="item"
                              :id="`scrollItem_${index}`"
                              :key="item.thread_id"
                              :name="item.target_name"
                              :avatar="item.target_avatar"
                              :unReadCount="item.unread"
                              :isRead="item.lastMsg?.read"
                              :message="item.lastMsg?.content?.payload?.txt ?item.lastMsg?.content?.payload.txt : ''"
                              :active="current === item.thread_id"
                              :time="item.update_time"
                              :online="item.online"
                              :type="item.type"
                              :msg-type="item.lastMsg?.content ? Number(item.lastMsg.content.type) : 1"
                              @click.native="changeCurrent(item, index)"
              />
              <morebar :status="pagination.status" @onmore="loadMoreThread"></morebar>
            </div>
          </el-scrollbar>
        </el-tab-pane>

        <!-- 私聊 -->
        <el-tab-pane label="私聊" :name="TabsMap['USER_LIST']">
          <el-scrollbar class="ls-scrollbar scrollbar-wrapper" v-loading="loading" v-if="this.tabsActiveIndex==1">
            <div
                style="height:640px"
                v-infinite-scroll="loadMoreThread"
                :infinite-scroll-disabled="busy"
                infinite-scroll-immediate-check="false"
                infinite-scroll-listen-for-event
                infinite-scroll-delay="200">
              <chat-user-item v-for="(item, index) in session_list[tabsActiveIndex]"
                              :star="item.star"
                              :bg="item.bg"
                              :data="item"
                              :id="`scrollItem_${index}`"
                              :key="item.thread_id"
                              :name="item.target_name"
                              :avatar="item.target_avatar"
                              :unReadCount="item.unread"
                              :isRead="item.lastMsg?.read"
                              :message="item.lastMsg?.content?.payload?.txt ?item.lastMsg?.content?.payload.txt : ''"
                              :active="current === item.thread_id"
                              :time="item.update_time"
                              :online="item.online"
                              :type="item.type"
                              :msg-type="item.lastMsg?.content ? Number(item.lastMsg.content.type) : 1"
                              @click.native="changeCurrent(item, index)"
              />
              <morebar :status="pagination.status" @onmore="loadMoreThread"></morebar>
            </div>
          </el-scrollbar>
        </el-tab-pane>

        <!-- 群聊 -->
        <el-tab-pane label="群聊" :name="TabsMap['GROUP_CHAT']">
          <el-scrollbar class="ls-scrollbar scrollbar-wrapper" v-loading="loading" v-if="this.tabsActiveIndex==2">
            <div
                style="height:640px"
                v-infinite-scroll="loadMoreThread"
                :infinite-scroll-disabled="busy"
                infinite-scroll-immediate-check="false"
                infinite-scroll-listen-for-event
                infinite-scroll-delay="200">
              <chat-user-item v-for="(item, index) in session_list[tabsActiveIndex]"
                              :star="item.star"
                              :bg="item.bg"
                              :data="item"
                              :id="`scrollItem_${index}`"
                              :key="item.thread_id"
                              :name="item.target_name"
                              :avatar="item.target_avatar"
                              :unReadCount="item.unread"
                              :isRead="item.lastMsg?.read"
                              :message="item.lastMsg?.content?.payload?.txt ?item.lastMsg?.content?.payload.txt : ''"
                              :active="current === item.thread_id"
                              :time="item.update_time"
                              :online="item.online"
                              :type="item.type"
                              :msg-type="item.lastMsg?.content ? Number(item.lastMsg.content.type) : 1"
                              @click.native="changeCurrent(item, index)"
              />
              <morebar :status="pagination.status" @onmore="loadMoreThread"></morebar>
            </div>
          </el-scrollbar>
        </el-tab-pane>

        <el-tab-pane  :name="TabsMap['BARGAIN_CHAT']">
            <div class="bargain_tab" slot="label">
              <span>议价</span>
              <div class="bargain_count" v-if="wait_deal_bargain_count > 0">
                {{ wait_deal_bargain_count<100?wait_deal_bargain_count:"99+" }}
              </div>
            </div>
          <el-scrollbar class="ls-scrollbar scrollbar-wrapper" v-loading="bargain_loading"
          v-if="tabsActiveIndex=='3'"
          >
          <bargain-item  :data="item" :key="index" v-for="(item,index) in bargain_list"></bargain-item>
          <morebar :status="bargain_pagination.status" @onmore="loadMoreBargain"></morebar>
          </el-scrollbar>
        </el-tab-pane>

        <el-tab-pane label="星标客户" :name="TabsMap['STAR_CHAT']">
          <el-scrollbar class="ls-scrollbar scrollbar-wrapper" v-loading="loading" v-if="this.tabsActiveIndex==4">
            <div
                style="height:640px"
                v-infinite-scroll="loadMoreThread"
                :infinite-scroll-disabled="busy"
                infinite-scroll-immediate-check="false"
                infinite-scroll-listen-for-event
                infinite-scroll-delay="200">
              <chat-user-item v-for="(item, index) in session_list[tabsActiveIndex]"
                              :star="item.star"
                              :bg="item.bg"
                              :data="item"
                              :id="`scrollItem_${index}`"
                              :key="item.thread_id"
                              :name="item.target_name"
                              :avatar="item.target_avatar"
                              :unReadCount="item.unread"
                              :isRead="item.lastMsg?.read"
                              :message="item.lastMsg?.content?.payload?.txt ?item.lastMsg?.content?.payload.txt : ''"
                              :active="current === item.thread_id"
                              :time="item.update_time"
                              :online="item.online"
                              :type="item.type"
                              :msg-type="item.lastMsg?.content ? Number(item.lastMsg.content.type) : 1"
                              @click.native="changeCurrent(item, index)"
              />
              <morebar :status="pagination.status" @onmore="loadMoreThread"></morebar>
            </div>
          </el-scrollbar>
        </el-tab-pane>


      </el-tabs>
    </div>
  </div>
</template>


<script>
import ChatUserItem from '@/components/ChatUserItem'
import ChatGroupItem from '@/components/ChatGroupItem'
import {userList, apiUserSerchById} from '@/api/app'
import LoadingMore from '@/components/LoadingMore'
import tip from '@/assets/tip.mp3'
import Morebar from "@/components/Morebar";
import {E_Load} from '@/utils/enum'
import yanhao from '@/assets/images/1.png';
import huanbang from '@/assets/images/2.png';
import wancheng from '@/assets/images/3.png';
import quxiao from '@/assets/images/4.png';
import jinyan from '@/assets/images/0.png';
import shouhou from '@/assets/images/5.png';
import yh from '@/assets/images/group_avatar_guarantee_1.png';
import hb from '@/assets/images/group_avatar_guarantee_2.png';
import wc from '@/assets/images/group_avatar_guarantee_3.png';
import qx from '@/assets/images/group_avatar_guarantee_4.png';
import qs from '@/assets/images/group_avatar_guarantee_5.png';
import {Message} from "element-ui";
import BargainItem from '@/components/BargainItem'
import { getBargainList,getBargainCount } from '../../../api/app';

export default {
  name: 'TheWindowAsideLeft',
  components: {
    ChatUserItem,
    ChatGroupItem,
    LoadingMore,
    Morebar,
    BargainItem
  },

  props: {
    current: {
      type: [String, Number],
      require: true,
    },
    kefu_id: {
      type: [String, Number]
    }
  },

  inject: ['send'],

  data() {
    return {
      busy: true,
      selectValue_title: 'UID',
      first_init:true,
      group_avatar: {
        0: jinyan,
        1: yanhao,
        2: huanbang,
        3: wancheng,
        4: quxiao,
        5: shouhou
      },
      group_avatar_guarantee:{
        1:yh,
        2:hb,
        3:wc,
        4:qx,
        5:qs
      },
      options: [
        {
          value: 'nickname',
          label: '昵称'
        },
        {
          value: 'mobile',
          label: '手机'
        },
        {
          value: 'userId',
          label: 'UID'
        },
        {
          value: 'group_status',
          label: '群状态'
        }

      ],
      selectValue: 'userId',
      /* 搜素内容 */
      searchValue: '',
      /* Tabs 索引 */
      tabsActiveIndex: '0',
      /* Tabs 映射 */
      TabsMap: Object.freeze({
        USER_LIST: '1',
        GROUP_CHAT: '2',
        BARGAIN_CHAT: '3',
        STAR_CHAT: '4',
        ALL_LIST: '0'
      }),
      /* 分页器 */
      pagination: {
        size: 9,
        page: 1,
        status: E_Load['LOAD'],
      },
      /* 议价列表分页 */
      bargain_pagination: {
        size: 9,
        page: 1,
        status: E_Load['LOAD'],
      },
      bargain_loading:true,
      /* 议价列表 */
      bargain_list: [],
      /*待回复处理*/
      dealing:[],
      wait_deal_bargain_count:0,
      /* 会话列表 */
      session_list: {
        "0": [],//全部
        "1": [],//私聊
        "2": [],//群组
        "4": []//星标用户
      },
      loading:true,
      user_list: [],
      thread_ids: [],//已加载的用户id
      readedList: [],//已读消息列表
      userId: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      group_status:null,
      tmp_user_add:null
    }
  },
  async created() {
    /* 初始化Tabs选项 */
    this.$event.$off("connected",this.init);
    this.$event.$on("connected",this.init);
    this.$event.$off("disconnected",this.disconnected);//断开
    this.$event.$on("disconnected",this.disconnected);//断开
    this.$event.$on("read_back",this.readBack);
    this.$event.$on('group_info_load',(data)=>{
      this.session_list[this.tabsActiveIndex] = this.session_list[this.tabsActiveIndex].map(item=>{
        if(item.group_id==data.group_id){
            item.group.deal_status = data.deal_status;
            item.target_avatar = this.group_avatar[item.group.deal_status];
            if(item.group.type===2){
              item.target_avatar = this.group_avatar_guarantee[item.group.deal_status];
            }
        }
        return item;
      });
      this.$forceUpdate();
    });
    // this.$event.$on("refreshKefu", this.userListFn);//刷新列表用于刷新自己的列表 即转接完成后我的列表减一
    this.$event.$on('open_private',async (uid)=>{
      this.selectValue = 'userId';
      this.searchValue = uid;
      this.handleSearch();
    });
    this.$event.$on("openGroupThread",(item)=>{
        this.tabsActiveIndex = "2";
        this.changeCurrent(item);
    });
  },
  mounted() {
    setInterval(()=>{
      console.log("待处理",this.dealing.length,"个会话")
      this.session_list[this.tabsActiveIndex] = this.session_list[this.tabsActiveIndex].map(item=>{
        if(this.dealing.includes(item.thread_id)){
          item.bg = true;
        }else{
          item.bg = false;
        }
        return item;
      });
      if(this.dealing.length>0){
        let audio = document.createElement('audio');
        if(audio){
          audio.src = tip;
          audio.play();
          audio.remove();
        }
      }
    },3000);
  },
  methods: {
    async getBargainList(){
      let res = await getBargainList({url: `?page_no=${this.bargain_pagination.page}&page_size=${this.bargain_pagination.size}&dept_id=${this.$net.userInfo.dept_id}`});
      this.bargain_list = [...this.bargain_list,...res.lists];
      this.bargain_pagination.status = res.count > this.bargain_list.length ? E_Load['NORMAL'] : E_Load['EMPTY'];
      this.bargain_loading = false;
    },
    async loadMoreBargain(){
      this.bargain_pagination.page++;
      await this.getBargainList();
    },
    //更换选项卡
    async tabClick(deal_status=null){
        if(this.tabsActiveIndex == 3){
          this.bargain_list= [];
          this.bargain_pagination.page = 1;
          await this.getBargainList();
          return;
        }
        this.pagination.page=1;
        this.session_list[this.tabsActiveIndex] = [];
        await this.userListFn(false,undefined,deal_status);
        let open = false;
        this.session_list[this.tabsActiveIndex].map(item=>{
            if(item.thread_id === this.tmp_user_add?.thread_id) {
                open = true;
                this.changeCurrent(item);
            }
          })
        if(open) return;
        if(this.tmp_user_add == null) return;
        this.session_list[this.tabsActiveIndex].unshift(this.tmp_user_add);
        this.tmp_user_add = null;
    },
    //订阅群消息
    async subGroup() {
      let groups = await this.$http.get("/tenantapi/kefu.kefu/groups");
      this.$net.socket.emit('subGroup',groups);
    },
    //撤回消息
    async recall(msg){
      //拉取用户列表
      this.session_list[this.tabsActiveIndex].map(item=>{
        if(item.type==='private' && 'user_'+item.user_id === msg.from){
            item.lastMsg.content.payload.txt = '撤回了一条消息';
        }
      })
    },
    //更新会话列表
    async conversationsUpdate(msg) {
        let kefu_id = 'kefu_'+ this.$net.userInfo.user_id;
        let updated = false;
        this.session_list[this.tabsActiveIndex].map(item => {
          if(item.thread_id?.toString() === msg.lastMsg.payload?.thread_id?.toString()){
            updated = true;
            if(msg.lastMsg.from == kefu_id){
              this.dealing.splice(this.dealing.indexOf(item.thread_id),1);
              item.bg = false;
            }else if(msg.msg_type==='private'){
              if(!this.dealing.includes(item.thread_id)) this.dealing.push(item.thread_id);
              item.bg = true;
            }
            if(msg.lastMsg.type != "6"){
              msg.lastMsg.read = msg.read.indexOf(kefu_id)>=0;
            }else{
              msg.lastMsg.read = item.lastMsg.read;
            }
            //消息未读则+1
            if(!msg.lastMsg.read&&!msg.unsent){
              item.unread = item.unread?item.unread+1:1;
            }
            //实时修改同步群组状态
            if(msg.update_group_status){
              item.group.deal_status = msg.deal_status;
              item.target_avatar = this.group_avatar[item.group.deal_status];
              if(item.group.type===2){
                item.target_avatar = this.group_avatar_guarantee[item.group.deal_status];
              }
            }
            item.lastMsg = msg.lastMsg;
            item.type = msg.lastMsg.msg_type;
            item.update_time = parseInt(msg.lastMsg.timestamp/1000);
          }
          return item;
        });
        if (!updated) {
          let user_id = "";
          if(msg.from?.includes("user_")){
            user_id = msg.from;
          }else{
            user_id = msg.to;
          }
          let thread_datas = {
            thread_id:msg.lastMsg.payload?.thread_id,
            lastMsg:msg.lastMsg,
            content:{payload:msg.lastMsg.payload},
            read:false,
            update_time:msg.lastMsg.timestamp,
            type:msg.lastMsg.msg_type,
            online:1,
            unread:1,
            user_id:user_id.replace("user_","")
          };
          if(msg.msg_type === "group"){
            //获取群组头像
            thread_datas.group_id = msg.to.replace("group_","");
            thread_datas.group = {group_id:thread_datas.group_id,name:msg.toData.name,deal_status:1};
            if(msg.toData){
              thread_datas.target_avatar  = this.group_avatar[msg.toData.deal_status];
              if(msg.toData.type===2){
                thread_datas.target_avatar = this.group_avatar_guarantee[msg.toData.deal_status];
              }
              thread_datas.target_name = msg.toData.name;
            }
            thread_datas.lastMsg.read = false;
          }else{
            //获取用户信息拿到头像
            thread_datas.target_avatar = msg.toData?.avatar;
            thread_datas.target_name =  msg.toData?.nickname;
            thread_datas.lastMsg.read = false;
            thread_datas.bg = true;
            if(msg.msg_type == "") msg.msg_type = "private";
          }
          this.session_list[this.tabsActiveIndex].push(thread_datas);
        }
        this.session_list[this.tabsActiveIndex] = this.session_list[this.tabsActiveIndex].sort((a, b) => {
          return a.update_time<=b.update_time?1:-1;
        })
    },
    readBack(message){

    },
    //分页查询用户列表
    async userListFn(openUserChatWindow = false, from = "normal",deal_status=null) {
        this.loading = true;
        const tabIndex = this.tabsActiveIndex;
        let chat_type = undefined;
        if(tabIndex == 3) return;
        if(tabIndex === '1') chat_type = "private";
        if(tabIndex === '2') chat_type = "group";
        if(tabIndex === '4') chat_type = "star";
        let res1 = await userList({url: `page_no=${this.pagination.page}&page_size=${this.pagination.size}`,type:chat_type,deal_status});
        //添加对象进入列表
       let c=0;
       this.dealing = res1.extend.dealing??[];

        res1.lists.map(item => {
            if(this.dealing.includes(item.thread_id)){
              item.bg = true;
            }
            //聊天会话类型
            if(item.type === 'group'){
              item.user_id = item.group_id;
              item.target_avatar = this.group_avatar[item.group.deal_status];
              if(item.group.type===2){
                item.target_avatar = this.group_avatar_guarantee[item.group.deal_status];
              }
              item.lastMsg.read = item.unread==0;
            }
            if (this.thread_ids.indexOf(item.thread_id) < 0 || this.tabIndex!=0) {
              if(!item.update_time){
                item.update_time = item.lastMsg.content?parseInt(item.lastMsg.content.timestamp/1000) : 0;
              }else{
                item.update_time = parseInt(new Date(item.update_time).getTime()/1000);
              }
              c++;
              this.session_list[this.tabsActiveIndex].push(item);
            }
            return item;
        });
        //显示更多
        if (this.session_list[this.tabsActiveIndex].length < res1.count) {
          this.pagination.status = E_Load["NORMAL"];
        } else {
          this.pagination.status = E_Load["EMPTY"];
          this.busy = true;
        }
        this.thread_ids = [];//清空对话ids
        this.$net.onlineUsers();

        this.session_list[this.tabsActiveIndex] = this.session_list[this.tabsActiveIndex].sort((a, b) => {
          return a.update_time<=b.update_time?1:-1;
        })
        if (openUserChatWindow) {
          this.openUserChatById();
        }
        this.loading =  false;
    },

    loadMoreThread() {
      this.pagination.page++;
      this.userListFn(false, "loadMoreThread");
    },

    async openUserChatById(data) {
      this.tabsActiveIndex = "1";
      //根据下列选择用户昵称 电话 id
      let itemToClick = this.session_list[this.tabsActiveIndex].find(item => {
        item.user_id = data.id
        item.bg = false;
      });
      if (itemToClick) {
        // 找到匹配项后，调用 changeCurrent 方法
        // 假设 changeCurrent 方法的第一个参数是用户对象，第二个参数是索引
        const index = this.session_list[this.tabsActiveIndex].indexOf(itemToClick); //使用数组方法indexOf获取元素下标位置
        this.changeCurrent(itemToClick, index);
        //搜索到该元素后 让其滚动到顶部
        let scrollItemView = document.getElementById('scrollItem_' + index)
        if (scrollItemView && index>=7) {
          scrollItemView.scrollIntoView({behavior: 'smooth'}); //使用dom元素带的方法scrollIntoView 让调用该方法的元素滚动到可视区域中
        }
      } else {
        if (data && data.id!==undefined) {
          this.$net.onlineUsers();
          let thread_datas = {
            thread_id:data.thread?.thread_id,
            lastMsg:data.thread?.lastMsg ?? null,
            content:data.thread?.lastMsg?.content ?? {payload:data.thread?.lastMsg?.payload ?? null},
            read:data.thread?.lastMsg?.read?? 1,
            update_time:data.thread?.update_time,
            type:data.thread?.lastMsg?.content?.msg_type??'private',
            online:0,
            unread:0,
            user_id:data.id,
            target_avatar:data.avatar,
            target_name:data.nickname,
            bg:false
          };
          this.session_list[this.tabsActiveIndex].unshift(thread_datas);
          //点击打开
          this.changeCurrent(this.session_list[this.tabsActiveIndex][0]);
          this.tmp_user_add = thread_datas;
          this.$forceUpdate();
        } else {
            Message.error("未找到该用户");
        }
      }
    },
    async init() {
        console.log("初始化左侧列表");
        this.busy = false;
        this.pagination.page = 1;
        this.bargain_pagination.page = 1;
        await this.subGroup();
        await this.userListFn();
        //销毁监听
        this.$net.socket.off('threadUpdate', this.conversationsUpdate.bind(this));
        this.$net.socket.off('onlineUser',this.setUserOnline.bind(this));
        this.$net.socket.off('offlineUser',this.setUserOffline.bind(this));
        this.$net.socket.off('recall',this.recall.bind(this));
        this.$net.socket.off('online',this.setOnlineUserStatus.bind(this));
        this.$net.socket.off('read',this.readMsg.bind(this));
        this.$net.socket.off('transfer',this.onTransfer.bind(this));
        this.$net.socket.off("message",this.getWaitDealBargainCount.bind(this));
        //建立监听
        this.$net.socket.on('threadUpdate',this.conversationsUpdate.bind(this));
        this.$net.socket.on('onlineUser',this.setUserOnline.bind(this));
        this.$net.socket.on('offlineUser',this.setUserOffline.bind(this));
        this.$net.socket.on('recall',this.recall.bind(this));
        this.$net.socket.on('online',this.setOnlineUserStatus.bind(this));
        this.$net.socket.on('read',this.readMsg.bind(this));
        this.$net.socket.on('transfer',this.onTransfer.bind(this));
        this.$net.socket.emit("getReSendMessage");
        this.$net.socket.on("message",this.getWaitDealBargainCount.bind(this));
        this.$event.$on("updateWaitBargainCount",this.getWaitDealBargainCount);
        this.getWaitDealBargainCount();
    },
    async getWaitDealBargainCount(){
        //获取议价待处理上标
        this.wait_deal_bargain_count = (await getBargainCount({
          url:"?dept_id="+this.$net.userInfo.dept_id
        })).count;
    },
    //已读消息回执
    readMsg(msg){
      let readed = msg.read.indexOf("kefu_"+this.$net.userInfo.user_id)>=0;
      //如果是自己已读
      if(msg.to=="kefu_"+this.$net.userInfo.user_id || readed){
         this.session_list[this.tabsActiveIndex].map(item=>{
            if(item.thread_id==msg.payload.thread_id) {
                item.unread = 0;
                this.$forceUpdate();//强制刷新样式
            }
            return item;
         })
       }
    },
    //拉取列表后设置成员在线状态
    setOnlineUserStatus(msg){
      console.log("设置在线状态",msg);
      let online_users = Object.values(msg);
      this.session_list[this.tabsActiveIndex] = this.session_list[this.tabsActiveIndex].map(item => {
          this.thread_ids.push(item.thread_id);
          if (item.type === "group") {
            item.target_avatar = this.group_avatar[item.group?.deal_status];
            if(item.group.type===2){
              item.target_avatar = this.group_avatar_guarantee[item.group.deal_status];
            }
          }
          if (online_users.indexOf("user_"+item.user_id) >= 0) {
            item.online = 1;
          }
          return item;
      });
      this.$forceUpdate();//强制刷新样式
    },
    //切换搜索条件
    onSelectSearch(val){
      if(val==='group_status'){
        this.tabsActiveIndex = "2";
      }
    },
    //搜索用户列表
    async handleSearch() {
      this.pagination.page = 1
      this.pagination.status = E_Load['LOAD']
      let key = this.selectValue;
      let datas={};
      datas[key] = this.searchValue;
      let data = await apiUserSerchById(datas);
      //根据下列选择用户昵称 电话 id
      if (data!=null) {
        this.userId = data.id
      }
      //打开搜索到的用户聊天
      this.openUserChatById(data)
    },
    //选择用户改变
    changeCurrent(item) {
      if (item.type === 'group') {
        item.user_id = item.group_id;
        item.target_avatar = this.group_avatar[item.group.deal_status];
        if(item.group.type===2){
          item.target_avatar = this.group_avatar_guarantee[item.group.deal_status];
        }
      }
      if(item.user_id==null){
        this.$message.error("用户UID不存在");
        return;
      }
      item.bg = false
      this.$emit('change', item.user_id, item.type, item.thread_id, item.target_avatar);
      if (item.lastMsg&&!item?.lastMsg.read) {
        item.lastMsg.read = 1;
        item.unread = 0;
        this.$forceUpdate();
      }
    },
    //用户实时上线
    setUserOnline(msg) {
      let user_id = msg.user_id;
      this.session_list[this.tabsActiveIndex].map(item => {
        if (item.user_id === user_id && item.type!=='group') {
          item.online = 1;
          this.$notify.success({
            title: '上线通知',
            message: `您正在对接的用户[${item.target_name}]上线`,
            position:'top-left'
          })
          this.$forceUpdate();
          return item;
        }
      });
    },

    //用户实时下线
    setUserOffline(msg) {
      this.session_list[this.tabsActiveIndex].map(item => {
        if (item.user_id === msg.user_id && item.type!=='group') {
          item.online = 0;
          this.$notify.error({
            title: '下线通知',
            message: `您正在对接的用户[${item.target_name}]下线`,
            position:'top-left'
          })
          this.$forceUpdate();
          return item;
        }
      });
    },
    //收到转接客服消息
    async onTransfer(msg){
        //被转接的客服收到消息
        if(msg.transfer_id==="kefu_"+this.$net.userInfo.user_id){
            // console.log({showClose: true,message: '收到一条转接消息',type: 'success'});
            this.$message({showClose: true,message: '收到一条转接消息',type: 'success'});
        }else if(msg.kefu_id==="kefu_"+this.$net.userInfo.user_id){
            // console.log({showClose: true,message: '转接了一条消息',type: 'success'});
        }
        //更新用户列表
        this.pagination.page = 1;
        this.session_list[this.tabsActiveIndex] = [];
        await this.userListFn();
        this.session_list[this.tabsActiveIndex] = this.session_list[this.tabsActiveIndex].map(item=>{
          if (item.user_id === msg.user_id) {
            item.bg = true;
          }
          return item;
        });
    },
    disconnected(){
      this.session_list= {
          "0": [],//全部
          "1": [],//私聊
          "2": [],//群组
          "4": []//星标用户
      };
    }
  },
  beforeDestroy() {
    this.$event.$off("connected",this.init);
    this.$event.$off("disconnected",this.disconnected);
    this.$net.socket.off('threadUpdate',this.conversationsUpdate.bind(this));
    this.$net.socket.off('onlineUser',this.setUserOnline.bind(this));
    this.$net.socket.off('offlineUser',this.setUserOffline.bind(this));
    this.$net.socket.off('recall',this.recall.bind(this));
    this.$net.socket.off('online',this.setOnlineUserStatus.bind(this));
    this.$net.socket.off('read',this.readMsg.bind(this));
    this.$net.socket.off('transfer',this.onTransfer.bind(this));
    this.$net.socket.off("message",this.getWaitDealBargainCount.bind(this));
  },
  watch:{
    tabsActiveIndex(){
      this.tabClick();
    }
  }
}
</script>


<style lang="scss" scoped>
.asideLeftContainer {
  box-sizing: border-box;
  height: 610px;

  .el-dropdown-link {
    cursor: pointer;
  }

  .searchContainer {
    .my-el-row {
      border: 1px solid #f3f3f3;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }

    .myInput {

      :deep(.el-input__inner) {
        border:0px solid red;
        border-radius: 0 !important;
      }
    }

    .searchBox{
      display: flex;
    }
    .searchLable{
      width: 55%;
      :deep(input){
        border:0px solid red;
      }
    }
    .searchInput{
      :deep(input){
        border:0px solid red;
      }
    }

  }

  .tabsContainer {
    .window__aside-left {
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
      width: 100%;



      :deep(.el-tabs__item ) {
        text-align: center;
        padding: 0;
      }

      :deep(.el-tabs__active-bar) {
        background: no-repeat url("https://www.xzyds.com/assets/underline-DRMhxnyS.png");
        height: 12px;
        background-position-x: center;
        background-size: 50% 100%;
      }


      :deep(.is-active) {
        font-weight: bold;
        font-size: 14px;
      }

      &::v-deep .el-tabs__content {
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .scrollbar-wrapper {
        flex: 1;
        height: 520px;
      }

      /deep/ .el-input__inner {
        height: 32px !important;
      }
    }

  }


  .el-icon-arrow-down {
    font-size: 12px;
  }


}
.bargain_tab{
  position: relative;
}
.bargain_count{
  position: absolute;
    width: 24px;
    height: 24px;
    right: -2px;
    top: 0px;
    font-size: 14px;
    line-height: 24px;
    background: rgba(255, 0, 0, 0.4);
    border-radius: 50%;
    color: #fff;
}

</style>
